import { ArrowLeft } from "lucide-react"

import ConfirmStar from "@/assets/img/compatibility/confirm-star.png"
import { Button } from "@/components/ui/button"
import type { StepComponentProps } from "./step-contract"

/**
 * Full-bleed email opt-in confirmation (Figma LPR_Quiz_Compatibility_Confirm):
 * a glowing star banner, title + description, and a primary "Confirm" / secondary
 * "No, thanks" pair — both advance to checkout (the choice only affects opt-in).
 * `secondaryAction.value` distinguishes the two for the stored answer.
 */
export function CompatibilityConfirmStep({ step, onChange, onAdvance, onBack }: StepComponentProps) {
  const confirm = (value: string) => {
    onChange(value)
    onAdvance()
  }

  return (
    <div className="flex flex-1 flex-col bg-dark-base text-purple-light">
      <div className="relative">
        <img src={ConfirmStar} alt="" className="h-[212px] w-full object-cover" />
        <div className="absolute inset-x-0 top-0 flex h-14 items-center px-4">
          <button
            type="button"
            onClick={onBack}
            aria-label="Go back"
            className="-ml-2 flex size-10 items-center justify-center rounded-full text-purple-light transition-colors hover:bg-purple-light/10"
          >
            <ArrowLeft className="size-6" />
          </button>
        </div>
      </div>

      <div className="flex flex-1 flex-col px-4 pb-6">
        <div className="mt-10 space-y-3 text-center">
          <h1 className="font-display text-2xl font-medium text-purple-light">{step.title}</h1>
          {step.subtitle && <p className="text-base text-purple-light/70">{step.subtitle}</p>}
        </div>

        <div className="mt-auto space-y-3 pt-6">
          <Button variant="gradient" size="xl" onClick={() => confirm("confirmed")}>
            Confirm
          </Button>
          <Button
            variant="ghost"
            size="xl"
            onClick={() => confirm(step.secondaryAction?.value ?? "declined")}
            className="bg-purple-light/10 text-purple-light hover:bg-purple-light/15"
          >
            {step.secondaryAction?.label ?? "No, thanks"}
          </Button>
        </div>
      </div>
    </div>
  )
}
